import { Easing, Tween, ViewerModule } from '@g.frame/core';
import { FBX_MODEL, TEXTURE } from '@g.frame/common.loaders';
import { Color, Group, MeshBasicMaterial, Vector2 } from 'three';
import { TextComponent } from '@g.frame/components.text';
import { deepClone } from '../../../utils/DeepClone';
export class WoodenSignComponent extends ViewerModule {
    constructor(loader, text) {
        super();
        this.loader = loader;
        this.text = text;
        this.container = new Group();
        this.highlighted = false;
        this.loader.addResources([
            {
                name: 'road_sign_model',
                type: FBX_MODEL,
                url: require('../../../../assets/models/leaves/road_sign.fbx')
            }, {
                name: 'wood_board_texture',
                type: TEXTURE,
                url: require('../../../../assets/textures/leaves/board/wood_board.png')
            },
        ]);
        this.addObject(this.container);
        this.textLabel = new TextComponent({
            size: new Vector2(0.18 * 2, 0.11 * 2),
            pxSize: new Vector2(512, 512 * 0.61),
            text: {
                value: this.text,
                autoWrappingHorizontal: false,
                autoWrapping: true,
                align: 'center',
                style: {
                    family: 'Gill-Sans',
                    weight: '600',
                    size: '80px',
                    color: '#4D2A12'
                },
                lineHeight: 90,
                margin: {
                    bottom: 40
                }
            },
            background: {
                color: 'transparent'
                // color: 'green'
            }
        });
        this.container.add(this.textLabel.uiObject);
        this.textLabel.uiObject.position.set(0, 0, 0.019);
        this.uiObject.raycast = (raycaster, intersects) => {
            const _intersects = [];
            this.uiObject.traverse(obj => {
                if (obj === this.uiObject)
                    return;
                obj.raycast(raycaster, _intersects);
            });
            _intersects.forEach(el => el.object = this.uiObject);
            intersects.push(..._intersects);
        };
        this.uiObject.userData.pickingMoveDistance = 1.3;
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.model = deepClone(this.loader.getResource('road_sign_model'));
        this.container.add(this.model);
        this.model.children[0].position.setScalar(0);
        this.model.scale.setScalar(0.008);
        this.model.traverse((el) => {
            if (el.name === 'wood_board' && el.material) {
                el.material = new MeshBasicMaterial({
                    map: this.loader.getResource('wood_board_texture'),
                });
                // @ts-ignore
                el.material.map.encoding = 3000;
            }
        });
    }
    highlight(red = true) {
        this.highlighted = red;
        const color = new Color(red ? '#ff0000' : '#ffffff');
        this.model.traverse((el) => {
            if (el.material) {
                // @ts-ignore
                el.material.color.copy(color);
            }
        });
    }
    update() {
        super.update();
    }
    flyTo(position, quaternion) {
        const oldQuaternion = this.uiObject.quaternion.clone();
        new Tween(this.uiObject.position)
            .to(position, 500)
            .easing(Easing.Cubic.Out)
            .onUpdate((i) => {
            this.uiObject.quaternion.copy(oldQuaternion).slerp(quaternion, i);
        })
            .start();
    }
}
